import Lottie from 'lottie-react';

import dog11Library from '../jsons/Dog_11_Library.json';

const Dog11Library = props => {
  return <Lottie animationData={dog11Library} {...props} />;
};

export default Dog11Library;
